import Highcharts from 'highcharts/highstock';
import getJSON from '~/js/helpers/xhr';
import moment from 'moment';

export default class StockChartCommon {

  constructor({chart, options}) {
/*
    this._chartsParams = [
      {
        id: 847,
        name: "divd",
        tabs: [
          {
            // вкладка Цена
            name: 'prices',
            charts: [
              {
                cod: 'DIVD',
                name: 'БПИФ ДОХОДЪ Индекс дивидендных акций',
                color: null,
                visible: true
              },
              {
                cod: 'DIVDA',
                name: 'Стоимость iNav (DIVDA)',
                color: '#52ae94',
                visible: false
              }
            ]
          },
          {
            // вкладка Доходность - во вкладке доходность значения вычисляются в процентах
            name: 'profitability',
            charts: [
              {
                cod: 'DIVD',
                name: 'БПИФ ДОХОДЪ Индекс дивидендных акций',
                color: null,
                visible: true
              },
              {
                cod: 'DIVDA',
                name: 'Стоимость iNav (DIVDA)',
                color: '#52ae94',
                visible: false
              },
              {
                cod: 'IRDIVTR',
                name: 'ДОХОДЪ Индекс дивидендных акций РФ (полной доходности)',
                color: '#ad033b'
              }
            ]
          },
        ]
      },
    ];
*/
    this._element = chart;
    this._options = options;
    this._originalOptions = Highcharts.merge(this._options);
    this._chart = this._element.querySelector(`.js-stock-chart`);
    this._legend = this._element.closest('.charts__block').querySelector(`.js-stock-chart-legend`);

    this._tab = this._chart.getAttribute(`data-tab`) ? this._chart.getAttribute(`data-tab`) : 'prices';
    this._type = this._chart.getAttribute(`data-type`) ? this._chart.getAttribute(`data-type`) : null;
    this._action = this._chart.getAttribute(`data-action`) ? this._chart.getAttribute(`data-action`) : null;
    this._resId = this._chart.getAttribute(`data-res-id`) ? this._chart.getAttribute(`data-res-id`) : null;

    let chartsParams = []
    getJSON(`/assets/components/dohod/connectorweb.php?action=chartsParams/get&resId=${this._resId}`).then((data) => {
      data.tabs = data.tabs.filter(tab => tab !== null)
      chartsParams.push(data)
      this._chartParam = chartsParams
        .filter(chart => chart.id == this._resId)[0].tabs
        .filter(types => types.name == this._tab)[0];

      this._setOffsetMins = this._setOffsetMins.bind(this);

      this._instance = null;
      this.init();

    })

      // this._chartParam = this._chartsParams
      // .filter(chart => chart.id == this._resId)[0].tabs
      // .filter(types => types.name == this._tab)[0];

  }

  /**
   * Вычисление смещения offsetMin для кнопок с периодами для следующих случаев:
   *  - для вычисленной библиотекой highcharts даты начала периода данные отсутствуют;
   *  - конечная точка на графике - "плавающая" отображает данные на текущим момент времени;
   *  - когда в месяце с конечной датой больше дней, чем в месяце с начальной датой (см. описание ниже).
   * Функция работает только в случае, если временные значения на графике
   * имеют одинаковое время суток и отличаются только днями (за исключением последней точки).
   * Для работы функции должна быть установлена и подключена библиотека moment.js.
   * Описание параметра offsetMin - https://api.highcharts.com/highstock/rangeSelector.buttons.offsetMin
   * Кнопки с периодами - https://api.highcharts.com/highstock/rangeSelector.buttons
   * @param hist - массив с данными для графика
   * @private
   */
  _setOffsetMins(hist) {
    if (this._options.rangeSelector.buttons.length) {

      let millisecondsInDay = 24 * 3600 * 1000;

      // последняя дата на графике с корректировкой времени из предпоследней даты
      // корректировка времени нужна, т. к. на некоторых графиках дата может быть с текущим временем
      // и в таком случае алгоритм данной функции не будет работать
      let periodEndDate = new Date(hist[hist.length - 1][0]);
      // предпоследняя дата на графике - из нее берем время и подставляем в дату-время последней точки
      let periodPrevEndDate = new Date(hist[hist.length - 2][0]);
      periodEndDate.setHours(periodPrevEndDate.getHours())
      periodEndDate.setMinutes(periodPrevEndDate.getMinutes())
      periodEndDate.setSeconds(periodPrevEndDate.getSeconds())

      // Когда последняя точка на графике плавающая - показывает время на текущий момент (см. страницы БПИФов),
      // то при выборе периода в 1 месяц и т. д. график не отображает первую точку.
      // Для решения этой проблемы вычисляем смещение последней точки от ее нормального положения (начало дня),
      // и прибавляем это смещение к вычисляемому текущей функцией смещению offsetMin.
      let offsetEndDateFromNorm = hist[hist.length - 1][0] -  periodEndDate.getTime();
      // console.log('offsetEndDateFromNorm - ' + offsetEndDateFromNorm);

      // начальная дата выбранного периода в unix - может отсутствовать
      let periodStartDateMilliseconds;

      this._options.rangeSelector.buttons.forEach(function (button) {
        switch (button.type) {
          case 'month':
            periodStartDateMilliseconds = moment(periodEndDate).subtract(button.count, 'months').unix()*1000;
            break;
          case 'year':
            periodStartDateMilliseconds = (moment(periodEndDate).subtract(button.count, 'years').unix() * 1000) - 10800000; //проверка на отступ
            break;
          case 'ytd':
            // последний день предыдущего года
            periodEndDate.setFullYear(periodEndDate.getFullYear());
            periodEndDate.setMonth(0);
            periodStartDateMilliseconds = periodEndDate.setDate(1);
            break;
          case 'all':
            periodStartDateMilliseconds = hist[0][0];
            break;
        }
        // вычисляем смещение только если дата начала периода больше первой точки графика
        if(periodStartDateMilliseconds > hist[0][0]) {

          // смещение offsetMin для кнопки графика, которое и будем вычислять
          let offsetMin = -offsetEndDateFromNorm;

          /*
            Есть некоторые дни в году в которые график ведет себя нестандартно и отображает
            в начале периода неожиданную дату. Например, если конечная точка  31 марта и выбран период 6 мес,
            то первая точка графика будет 1 октября вместо ожидаемых 30 сентября
            и для коррекции нужно добавлять смещение -(24 * 3600 * 1000 * 1 (день)).
            Такое поведение связано с тем, что в месяце с конечной датой больше дней, чем в месяце с начальной
            например, в марте 31 день, а в октябре (период 6 месяцев) 30 дней.
            Обработки исключительных ситуаций приведена ниже.
          */
          /////////////////////////////////////////////////////////////////////////////////////////////////////////////
          let endDate = new Date(hist[hist.length - 1][0]);
          let lastMonth = endDate.getMonth();
          let lastDay = endDate.getDate();
          let lastYear = endDate.getFullYear();
          // високосные года
          let leapYear = [2028, 2024, 2020, 2016, 2012, 2008];
          let leapText = leapYear.includes(lastYear) ? 'високосный год' : 'не високосный год';

          if(button.type === 'month') {
            // март (2) -- 31 - 6 мес
            if(lastMonth === 2 && lastDay === 31 && button.count === 6) {
              // console.log('Нестандартная ситуация ' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
              offsetMin += -millisecondsInDay;
            }
            // май (4) - 29 30 31 -- 3 мес
            // август (7) -- 29 30 31 - 6 мес
            if((lastMonth === 4 && button.count === 3) || (lastMonth === 7 && button.count === 6)) {
              switch (lastDay) {
                case 29:
                  // console.log('Нестандартная ситуация (' + leapText + ')' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
                  offsetMin += leapYear.includes(lastYear) ? 0 : -millisecondsInDay*1;
                  break;
                case 30:
                  // console.log('Нестандартная ситуация (' + leapText + ')' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
                  offsetMin += leapYear.includes(lastYear) ? -millisecondsInDay*1 : -millisecondsInDay*2;
                  break;
                case 31:
                  // console.log('Нестандартная ситуация (' + leapText + ')' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
                  offsetMin += leapYear.includes(lastYear) ? -millisecondsInDay*2 : -millisecondsInDay*3;
                  break;
              }
            }
            // май (4) - 31 - 6 мес
            if(lastMonth === 4 && lastDay === 31 && button.count === 6) {
              // console.log('Нестандартная ситуация ' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
              offsetMin += -millisecondsInDay;
            }
            // июль (6) -- 31 - 3 мес
            if(lastMonth === 6 && lastDay === 31 && button.count === 3) {
              // console.log('Нестандартная ситуация ' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
              offsetMin += -millisecondsInDay;
            }
            // октябрь (9) -- 31 - 6 мес
            if(lastMonth === 9 && lastDay === 31 && button.count === 6) {
              // console.log('Нестандартная ситуация ' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
              offsetMin += -millisecondsInDay;
            }
            // декабрь (11) -- 31 - 3 мес; 31 - 6 мес
            if(lastMonth === 11 && lastDay === 31 && (button.count === 3 || button.count === 6)) {
              // console.log('Нестандартная ситуация ' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
              offsetMin += -millisecondsInDay;
            }
          }
          // високосный год 29 февраля (1) - 1 год
          if(button.type === 'year' && leapYear.includes(lastYear) && lastMonth === 1 && lastDay === 29) {
            // console.log('Нестандартная ситуация ' + lastDay + '-й день ' + (lastMonth + 1) + '-й месяц, смещение ' + button.count + button.type);
            offsetMin += -millisecondsInDay;
          }
          /////////////////////////////////////////////////////////////////////////////////////////////////////////////

          // значение в точке графика - сначала в начале периода, потом со смещением на один день назад
          let itemOffset;
          // временная переменная для хранения времени смещения назад по точкам графика для поиска ближайшей точки
          let periodStartDateMillisecondsTemp = periodStartDateMilliseconds;
          // поиск значения на графике
          // количество итераций - необходимо для корректировки ytd
          let j = 0;
          while (itemOffset === undefined && j < 100) {
            itemOffset = hist.find(item => item[0] === periodStartDateMillisecondsTemp);
            // корректировка для ytd - на первой итерации, если значение для 01 января найдено, равно продолжаем поиск
            if (button.type === 'ytd' && j === 0 && itemOffset !== undefined) {
              periodStartDateMillisecondsTemp -= millisecondsInDay;
              itemOffset = hist.find(item => item[0] === periodStartDateMillisecondsTemp);
            }
            if (itemOffset === undefined) {
              periodStartDateMillisecondsTemp -= millisecondsInDay;
            }
            j++;
          }
          if (itemOffset !== undefined) {
            offsetMin += itemOffset[0] - periodStartDateMilliseconds;
          } else {
            // console.log(periodStartDateMilliseconds, 'periodStartDateMilliseconds');
            // console.log(hist[0][0], 'hist[0][0]');
            // console.log('!!! not offsetMin for ' + (button.count !== undefined ? button.count : '') + ' ' + button.type + ' - ' + offsetMin);
          }
          button['offsetMin'] = offsetMin;
          // console.log('offsetMin for ' + (button.count !== undefined ? button.count : '') + ' ' + button.type + ' - ' + offsetMin);
        }
      });
    }
  }

  init() {

    if(!(this._tab && this._action && this._resId && this._type)) {
      // console.log('Отсутствуют data атрибуты data-tab, data-type, data-action, data-res-id.');
    }
    else {
      super.init();
    }
  }

}
